import * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

function Toaster({ theme = 'system', ...props }: ToasterProps) {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-right"
      closeButton
      richColors
      duration={4000}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--font-family': 'var(--font-sans)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
export { toast } from 'sonner';
